
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/academy-for-international-relations",
      function () {
        return require("private-next-pages/academy-for-international-relations/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/academy-for-international-relations"])
      });
    }
  